import * as React from 'react';

import { cn } from '@rematter/ui-web/lib';
import { CheckIcon } from 'lucide-react';

interface StepIndicatorProps {
  steps: Array<{
    number: number;
    title: string;
  }>;
  currentStep: number;
}

/*
 * @deprecated Use StepIndicator from @rematter/ui-web instead of this component
 */
export const StepIndicator: React.FC<StepIndicatorProps> = ({
  steps,
  currentStep,
}) => (
  <div className="@StepIndicator flex gap-3">
    {steps.map((step, index) => {
      const isCompleted = step.number < currentStep;
      const isCurrent = step.number === currentStep;

      return (
        <React.Fragment key={step.number}>
          <div
            className={cn(
              'flex items-center text-sm',
              (isCompleted || isCurrent) && 'text-success',
            )}
          >
            <div
              className={cn(
                'relative mr-2 flex size-6 items-center justify-center rounded bg-neutral/5 text-xs',
                isCompleted && 'bg-success text-white',
                isCurrent && 'border border-success bg-success/20 text-success',
              )}
            >
              {isCompleted ? (
                <CheckIcon className="size-4" />
              ) : (
                <span>{step.number}</span>
              )}
            </div>
            <span className="font-normal">{step.title}</span>
          </div>
          {index < steps.length - 1 && (
            <div className="w-4 self-center border-t border-neutral/30" />
          )}
        </React.Fragment>
      );
    })}
  </div>
);
